// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__uFTPv","secondary":"Button_secondary__otm0u","arrow":"Button_arrow__UArc2"};